export default __webpack_public_path__ + "static/media/heroBackground.198fd253.jpeg";